<template lang="pug">
div
  BriqInput.mb-S(label="Name - single" placeholder="i.e. adult" v-model="fields.Name" :disabled="isSaving" required data-test-id="segment-name-single")
  BriqInput.mb-S(label="Name - plural" placeholder="i.e. adults" v-model="fields.NamePlural" :disabled="isSaving" required data-test-id="segment-name-plural")
  BriqTextarea.mb-S(label="Description" placeholder="i.e. age 18-64" v-model="fields.Description" :disabled="isSaving" data-test-id="segment-description")
  .mb-S.segment-edit-fields-color-picker
    label.typo__label Color*
    multiselect(
      v-model="fields.colorObject"
      :options="colorOptions"
      :searchable="false"
      placeholder="Select a color"
      :disabled="isSaving"
      data-test-id="segment-color"
      )
      template(slot="singleLabel" slot-scope="props")
        .flex-center
          ColorIndicator(:color="props.option.color" borderRadius="2px" size="20px")
          span.ml-1em {{ props.option.name }}
      template(slot="option" slot-scope="props")
        .flex-center
          ColorIndicator(:color="props.option.color" borderRadius="2px" size="20px")
          span.ml-1em {{ props.option.name }}
  BriqCheckbox(label="Enabled" v-model="fields.enabled" :disabled="isSaving || !canCreateSegments" :error="disableError")
</template>

<script>
import Multiselect from 'vue-multiselect'
import ColorIndicator from '@/vue/settings/application/visitorclassifications/ColorIndicator.vue'

export default {
  components: { Multiselect, ColorIndicator },
  name: 'SegmentEditFields',
  props: {
    fields: Object,
    canCreateSegments: Boolean,
    isSaving: Boolean,
    colorOptions: Array,
    disableError: String,
  },
}
</script>

<style lang="stylus" scoped>
.flex-center
  display flex
  align-items center
.ml-1em
  margin-left 1em
</style>
